const AdminPrivateRoutesURLs = {
  home: "/admin/home",
};

export default AdminPrivateRoutesURLs;
